import React, { useCallback, useEffect } from "react";

/**
 * @template {keyof HTMLElementEventMap} T
 * @param {HTMLElement | Window} target 
 * @param {T} event 
 * @param {(e: HTMLElementEventMap[T]) => any} listener 
 * @param {React.DependencyList} deps 
 */
export default function useEventListener(target, event, listener, deps = []) {
    const eventListener = useCallback(listener, deps);

    useEffect(() => {
        target.addEventListener(event, eventListener);
        return () => target.removeEventListener(event, eventListener);
    }, deps);
}